import { withTheme } from '../config';
import { Button } from '@rneui/base/dist/Button/Button';
export { Button };
export default withTheme(Button, 'Button');
